import { Injectable } from "@angular/core";
import { ResourceService } from "./resource.service";
import { ProcessModel } from "../model/process.model";
import { HttpClient, HttpParams } from "@angular/common/http";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";

@Injectable({
    providedIn: 'root'
})
export class GatewayConnectorsService extends ResourceService<any> {

    constructor(
        http: HttpClient,
        settings: GlobalSettings,
        authService: AuthenticationService) {
        super(http, "gateway/Connectors", settings.processosUrl, authService)
    }

    authenticateAzure(authorizationCode: string, codeVerifier: string, siteUrl: string, redirectUri: string) {
        const formData = new FormData();
        formData.append('authorizationCode', authorizationCode);
        formData.append('codeVerifier', codeVerifier);
        formData.append('siteUrl', siteUrl);
        formData.append('redirectUri', redirectUri);
    
        return this.postFormData("Azure/Authenticate", formData);
    }
}